import pagesIndividualApprovalTasksEn from './approval-tasks/default';
import pagesIndividualApprovalsEn from './approvals/default';
import pagesIndividualContractEn from './contract';
import pagesIndividualHomeEn from './home/default';
import pagesIndividualMyProfileEn from './my-profile/default';
import pagesIndividualOperationPackageEn from './operation-package/default';
import pagesIndividualOperationTasksEn from './operation-tasks/default';
import pagesIndividualRequestTasksEn from './request-tasks/default';
import pagesIndividualTasksEn from './tasks/default';

export default {
  approvalTasks: pagesIndividualApprovalTasksEn,
  approvals: pagesIndividualApprovalsEn,
  contract: pagesIndividualContractEn,
  home: pagesIndividualHomeEn,
  myProfile: pagesIndividualMyProfileEn,
  operationPackage: pagesIndividualOperationPackageEn,
  operationTasks: pagesIndividualOperationTasksEn,
  requestTasks: pagesIndividualRequestTasksEn,
  tasks: pagesIndividualTasksEn,
};
